// extracted by mini-css-extract-plugin
export var button = "_dw-4";
export var hasDarkBackground = "_dw-7";
export var hasLightBackground = "_dw-6";
export var iconWrapper = "_dw-0";
export var large = "_dw-2";
export var medium = "_dw-1";
export var small = "_dw-5";
export var xsmall = "_dw-3";